// initial state
// shape: [{ id, quantity }]

const state = {
  allMenuCache: {},
  headerMenus: [
    {
      title: "活力魔方",
      i18nTitle: "",
      id: "016",
      name: "vibrantRubikCube",
      pid: "-1",
      icon: "",
      perm: "",
      href: "",
      children: [
        {
          title: "活力魔方",
          i18nTitle: "",
          id: "01601",
          name: "vibrantRubikCubeC",
          pid: "016",
          icon: "ios-people",
          perm: "",
          href: "",
          children: [
            {
              title: "自定义表单",
              i18nTitle: "",
              id: "0160102",
              name: "customFormList",
              pid: "01601",
              icon: "",
              perm: "",
              href: "vibrantRubikCube/customForm/list"
            }
          ]
        }
      ]
    }
  ]
};

const setAllMenuMap = function(datas) {
  for (let i = 0; i < datas.length; i++) {
    let m = datas[i];
    state.allMenuCache[m.href] = m;
    if (m.children && m.children.length > 0) {
      setAllMenuMap(m.children);
    }
  }
};

// getters
const getters = {
  getHeaderMenus: (state, getters, rootState) => {
    return state.headerMenus;
  },
  getMenuByHref: (state, getters, rootState) => href => {
    if (Object.keys(state.allMenuCache).length === 0) {
      setAllMenuMap(state.headerMenus);
    }
    return state.allMenuCache[href];
  }
};

// actions
const actions = {
  getApiHeaderMenus({ state, commit }, product) {
    commit("setHeaderMenus", null);
  }
};

// mutations
const mutations = {
  setHeaderMenus(state, { headerMenus }) {
    state.headerMenus = headerMenus;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js